// import React from 'react';
// import PortfolioProjects from './PortfolioProjects';
// import './Portfolio.css';

// const Portfolio = () => {
//   return (
//     <section id="portfolio">
//       <div className="portfolio">
//         <div className="portfolio-container">
//           <div className="projects-section">
//             <PortfolioProjects items={4} />
//           </div>
//           <div className=" flex justify-center items-center text-white text-base ">
//             <button className="border-2 border-primary px-7 py-2">
//               <a
//                 href="https://github.com/phrubel"
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 See More....
//               </a>
//             </button>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default Portfolio;

import React, { useState } from 'react';
import PortfolioProjects from './PortfolioProjects';
import './Portfolio.css';

const Portfolio = () => {
  const [activeTab, setActiveTab] = useState('all');

  return (
    <section id="portfolio">
      <div className="portfolio">
        <div className="flex justify-center">
          <h2 className="text-white text-center font-extrabold text-4xl relative z-20  ">
            RECENT PROJECTS.
          </h2>
          <svg
            class="absolute mt-[20px]"
            width="175"
            height="30"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              id="pathItem"
              d="M5 20 Q 70 0 150 20"
              stroke="#E12457"
              fill="transparent"
              stroke-width="7"
              stroke-linecap="round"
            ></path>
          </svg>
        </div>
        <div className="portfolio-container">
          {/* === NAVIGATION TABS === */}
          <div className="flex justify-center gap-2 md:gap-5 mb-8 mt-20">
            <button
              className={`px-5 py-2 border-2 rounded-md ${
                activeTab === 'all'
                  ? 'bg-primary text-white border-primary'
                  : 'border-white text-white'
              }`}
              onClick={() => setActiveTab('all')}
            >
              All Projects
            </button>

            <button
              className={`px-5 py-2 border-2 rounded-md ${
                activeTab === 'mobile'
                  ? 'bg-primary text-white border-primary'
                  : 'border-white text-white'
              }`}
              onClick={() => setActiveTab('mobile')}
            >
              Mobile App
            </button>

            <button
              className={`px-5 py-2 border-2 rounded-md ${
                activeTab === 'backend'
                  ? 'bg-primary text-white border-primary'
                  : 'border-white text-white'
              }`}
              onClick={() => setActiveTab('backend')}
            >
              Backend
            </button>
          </div>

          {/* === PROJECTS SECTION === */}
          <div className="projects-section">
            <PortfolioProjects category={activeTab} items={4} />
          </div>

          {/* === SEE MORE BUTTON === */}
          <div className="flex justify-center items-center text-white text-base mt-6">
            <button className="border-2 border-primary px-7 py-2">
              <a
                href="https://github.com/phrubel"
                target="_blank"
                rel="noreferrer"
              >
                See More....
              </a>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
